export const MIN_MESSAGE_LENGTH = 50
export const MAX_MESSAGE_LENGTH = 1000
export const INITIAL_MESSAGE =
  'Я виртуальный помощник. Отвечу на вопросы о пунктах выдачи. Например, расскажу, какие есть требования к помещению или как активировать пункт.\n\nЕсли у меня не получится ответить на вопрос или вы хотите пообщаться с человеком, нажмите «Задать вопрос менеджеру»'
